import request from "../Requests/requests";
import { getTags } from "./getTag";


export const removeTagsToList = (payload) => {
    return async dispatch => {
        try {
            const response = await request.delete('/Tag?Id=' + payload)
            .then(() => dispatch(getTags()))
            const data = response.data
            return data
        } catch (error) {
            return error
        }
    }
}